const accessKey = 'helix.accessToken';
const refreshKey = 'helix.refreshToken';

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
}

export function getAccessToken(): string | null {
  return getStoredValue(accessKey);
}

export function getRefreshToken(): string | null {
  return getStoredValue(refreshKey);
}

export function hasSessionTokens(): boolean {
  return getAccessToken() !== null || getRefreshToken() !== null;
}

export function setTokens(tokens: StoredTokens): void {
  localStorage.setItem(accessKey, tokens.accessToken);
  localStorage.setItem(refreshKey, tokens.refreshToken);
  sessionStorage.removeItem(accessKey);
  sessionStorage.removeItem(refreshKey);
}

export function clearTokens(): void {
  localStorage.removeItem(accessKey);
  localStorage.removeItem(refreshKey);
  sessionStorage.removeItem(accessKey);
  sessionStorage.removeItem(refreshKey);
}

function getStoredValue(key: string): string | null {
  const localValue = localStorage.getItem(key);
  if (localValue !== null) return localValue;

  const legacySessionValue = sessionStorage.getItem(key);
  if (legacySessionValue !== null) localStorage.setItem(key, legacySessionValue);
  return legacySessionValue;
}
